import React from 'react';
import { useState } from 'react';
import { Routes, Route, useParams, useLocation, useNavigate } from 'react-router-dom';
import './RecipeItem.css'

const RecipeItem = (props)=>{

    const [recipeID,setRecipeID] = useState(props.id);
    const [name,setName] = useState(props.name);
    const [image,setImage] = useState(props.image);
    const navigate = useNavigate();
    const renderRecipe = (event)=>{
        let recipeobj = {id:recipeID,name:name,image:image}
        props.renderRecipe(recipeobj)
    };

    const renderCategory = (event)=>{

        props.renderCategory(event.target.id)

    };

    let jsxcategories=[]

    //preventing empty arrays from executing
    if(props.category.length>0){
        props.category.forEach(category => {

            //handles empty entry in category list
            if(category.trim()){
            jsxcategories.push(
                <li key={category}>
                    <a className='category tag' id={category} onClick={renderCategory}>
                    {category}
                    </a>
                </li>
            )
            }
            
        });

    //handles empty array and classifies as none category
    }else{
        jsxcategories.push(
            <li key={"none"}>
                <a className='category tag' id={'none'} onClick={renderCategory}>
                {''}
                </a>
            </li>
        )
    }

    
    
    
        
    return(
        <div className="recipe-item" key={recipeID} id={recipeID}>

            <img width="400" height="267" src={props.image} onClick={()=>navigate(`/recipes/${recipeID}`)}/>
            <ul className='tags'>
            {jsxcategories}
            </ul>
            <div className='container recipe-item-title' onClick={()=>navigate(`/recipes/${recipeID}`)}>
            <p>{props.recipe}</p>
            </div>
            
            
            
        </div>
    )
};

export default RecipeItem;